import Home from "./pages/Home";
import { ROLES } from "./constant/constants";
import Order from "./pages/Order";
import Food from "./pages/Food";
import ComboMenu from "./pages/SetMenu";
import Category from "./pages/Category";
import Staff from "./pages/Staff";
import Profile from "./pages/Profile";
import ChangePassword from "./pages/ChangePassword";
import ForgetPassword from "./pages/ForgetPassword";
import NewPassword from "./pages/NewPassword";
import Restaurant from "./pages/Restaurant";
import Users from "./pages/Users";
import RestaurantCreate from "./pages/RestaurantCreate";
import Group from "./pages/Group";
import RestaurantDetails from "./pages/RestaurantDetails";
import BranchCreate from "./pages/BranchCreate";
import BranchEdit from "./pages/BranchEdit";
import BranchDetail from "./pages/BranchDetail";
import RestaurantEdit from "./pages/RestaurantEdit";
// import AddOrder from "./pages/OrderAdd";
import OrderAdd from "./pages/OrderAdd";
// import EditOrder from "./pages/OrderEdit";
import OrderEdit from "./pages/OrderEdit";
import OrderDetails from "./pages/OrderDetails";
import SetMenu from "./pages/SetMenu";
import SetMenuEdit from "./pages/SetMenuEdit";
import RestaurantQr from "./pages/RestaurantQr";
import FoodAdd from "./pages/FoodAdd";
import FoodEdit from "./pages/FoodEdit";
import Otp from "./pages/Otp";
import SalesReport from "./pages/reports/SalesReport";
import ItemWiseSalesReport from "./pages/reports/ItemWiseSalesReport";
import RefundReport from "./pages/reports/RefundReport";
import CustomerReport from "./pages/reports/CustomersReport";
import OrderReport from "./pages/reports/OrdersReport";
import OrderReportDetails from "./pages/reports/details/OrderReportDetails";
import SuperAdminOrderList from "./pages/super-admin/OrderList";
import DisbursementHistory from "./pages/super-admin/DisbursementHistory";
import Disbursement from "./pages/super-admin/Disbursement";
import OrdersReportArchived from "./pages/reports/OrdersReportArchived";
import RestaurantSwitch from "./pages/super-admin/RestaurantSwitch";
import IngredientAdd from "./pages/inventory/ingredients/IngredientAdd";
import Ingredients from "./pages/inventory/ingredients";
import IngredientEdit from "./pages/inventory/ingredients/IngredientEdit";
import PurchaseItemReports from "./pages/inventory/purchase-item/PurchaseItemReports";
import PurchaseItemAdd from "./pages/inventory/purchase-item/PurchaseItemAdd";
import PurchaseItemEdit from "./pages/inventory/purchase-item/PurchaseItemEdit";
import SupplierList from "./pages/inventory/supplier";
import SupplierAdd from "./pages/inventory/supplier/SupplierAdd";
import SupplierEdit from "./pages/inventory/supplier/SupplierEdit";
import InventoryReport from "./pages/inventory/report";
import RecipeList from "./pages/inventory/recipe";
import RecipeDetails from "./pages/inventory/recipe/RecipeDetails";
import RecipeAdd from "./pages/inventory/recipe/RecipeAdd";
import RecipeEdit from "./pages/inventory/recipe/RecipeEdit";
import WastageList from "./pages/inventory/wastage";
import WastageAdd from "./pages/inventory/wastage/WastageAdd";
import WastageEdit from "./pages/inventory/wastage/WastageEdit";
import InventoryFinalReport from "./pages/inventory/final-report";
import PrinterSettings from "./pages/PrinterSettings";
import SettingsSuperAdmin from "./pages/super-admin/SettingsSuperAdmin";
import AddMealAddition from "./pages/AddMealAddition";
import TableManagement from "./pages/TableManagement";
import AddTable from "./pages/AddTable";
import RestaurantFloorPlan from "./pages/RestaurantFloorPlan";
import WaiterList from "./pages/waiter/list";
import WaiterAssign from "./pages/waiter/assign";
import OrderPayment from "./pages/OrderPayment";
import OrderPaymentSplit from "./pages/OrderPaymentSplit";
import CommonDashboard from "./pages/CommonDashboard";
import CouponSettingsList from "./pages/settings/coupon/CouponSettingsList";
import CouponAdd from "./pages/settings/coupon/CouponAdd";
import CouponEdit from "./pages/settings/coupon/CouponEdit";
import CouponReport from "./pages/reports/CouponReport";

// Public routes that don't require authentication
export const publicRoutes = [
  { path: "/forget-password", element: <ForgetPassword /> },
  { path: "/otp", element: <Otp /> },
  {
    path: "/change-password",
    element: <ChangePassword />,
  },
  {
    path: "/set-new-password",
    element: <NewPassword />,
  },
];

export const roleBasedRoutes = [
    { path: "/", roles: [ROLES.ADMIN, ROLES.STAFF, ROLES.SUPER_ADMIN], element: <CommonDashboard /> },
    { path: "/dashboard", roles: [ROLES.ADMIN, ROLES.STAFF], element: <Home /> },
    { path: "/food", roles: [ROLES.ADMIN, ROLES.STAFF], element: <Food /> },
    { path: "/set-menu", roles: [ROLES.ADMIN, ROLES.STAFF], element: <SetMenu /> },
    { path: "/restaurant-qr", roles: [ROLES.ADMIN, ROLES.STAFF, ROLES.SUPER_ADMIN], element: <RestaurantQr /> },
    { path: "/food/add", roles: [ROLES.ADMIN, ROLES.STAFF], element: <FoodAdd /> },
    { path: "/food/edit/:foodName/:foodId", roles: [ROLES.ADMIN, ROLES.STAFF], element: <FoodEdit /> },
    { path: "/set-menu/edit/:setMenuId", roles: [ROLES.ADMIN, ROLES.STAFF], element: <SetMenuEdit /> },
    { path: "/category", roles: [ROLES.ADMIN, ROLES.STAFF], element: <Category /> },
    { path: "/staff", roles: [ROLES.ADMIN, ROLES.STAFF], element: <Staff /> },
    { path: "/profile", roles: [ROLES.ADMIN, ROLES.STAFF], element: <Profile /> },
    { path: "/printer-settings", roles: [ROLES.ADMIN, ROLES.STAFF], element: <PrinterSettings /> },
    { path: "/coupon-settings", roles: [ROLES.ADMIN, ROLES.STAFF], element: <CouponSettingsList /> },
    { path: "/coupon-settings/coupon/add/", roles: [ROLES.ADMIN, ROLES.STAFF], element: <CouponAdd /> },
    { path: "/coupon-settings/coupon/:couponId/edit", roles: [ROLES.ADMIN, ROLES.STAFF], element: <CouponEdit /> },
    { path: "/coupon-settings/coupon/:couponId/relaunch", roles: [ROLES.ADMIN, ROLES.STAFF], element: <CouponEdit /> },
    // { path: "/change-password", roles: [ROLES.ADMIN, ROLES.STAFF], element: <ChangePassword /> },
    // { path: "/forget-password", roles: [ROLES.ADMIN, ROLES.STAFF], element: <ForgetPassword /> },
    // { path: "/otp", roles: [ROLES.ADMIN, ROLES.STAFF], element: <OTP /> },
    // { path: "/set-new-password", roles: [ROLES.ADMIN, ROLES.STAFF], element: <NewPassword /> },

    /** Order -Admin **/
    { path: "/order", roles: [ROLES.ADMIN, ROLES.STAFF], element: <Order /> },
    { path: "/table", roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN], element: <TableManagement /> },
    { path: "/order/add", roles: [ROLES.ADMIN, ROLES.STAFF], element: <OrderAdd /> },
    { path: "/order/:orderId/edit", roles: [ROLES.ADMIN, ROLES.STAFF], element: <OrderEdit /> },
    { path: "/order/:orderId/details", roles: [ROLES.ADMIN, ROLES.STAFF], element: <OrderDetails /> },
    { path: "/order/:orderId/payment", roles: [ROLES.ADMIN, ROLES.STAFF], element: <OrderPayment /> },
    { path: "/order/:orderId/split-bill", roles: [ROLES.ADMIN, ROLES.STAFF], element: <OrderPaymentSplit /> },

    /** Reports */
    { path: "/reports/sales", roles: [ROLES.ADMIN, ROLES.STAFF], element: <SalesReport /> },
    { path: "/reports/item-wise-sales", roles: [ROLES.ADMIN, ROLES.STAFF], element: <ItemWiseSalesReport /> },
    { path: "/reports/refunds", roles: [ROLES.ADMIN, ROLES.STAFF], element: <RefundReport /> },
    { path: "/reports/customers", roles: [ROLES.ADMIN, ROLES.STAFF], element: <CustomerReport /> },
    { path: "/reports/orders", roles: [ROLES.ADMIN, ROLES.STAFF], element: <OrderReport /> },
    { path: "/reports/orders/:orderId/details", roles: [ROLES.ADMIN, ROLES.STAFF], element: <OrderReportDetails /> },
    { path: "/reports/coupons", roles: [ROLES.ADMIN, ROLES.STAFF], element: <CouponReport /> },

    /** Inventory */
    { path: "/inventory/ingredients", roles: [ROLES.ADMIN, ROLES.STAFF], element: <Ingredients /> },
    { path: "/inventory/ingredients/add", roles: [ROLES.ADMIN, ROLES.STAFF], element: <IngredientAdd /> },
    { path: "/inventory/ingredients/:ingredientId/edit", roles: [ROLES.ADMIN, ROLES.STAFF], element: <IngredientEdit /> },

    { path: "/inventory/purchase-item/reports", roles: [ROLES.ADMIN, ROLES.STAFF], element: <PurchaseItemReports /> },
    { path: "/inventory/purchase-item/add", roles: [ROLES.ADMIN, ROLES.STAFF], element: <PurchaseItemAdd /> },
    { path: "/inventory/purchase-item/:purchaseItemId/edit", roles: [ROLES.ADMIN, ROLES.STAFF], element: <PurchaseItemEdit /> },

    { path: "/inventory/supplier", roles: [ROLES.ADMIN, ROLES.STAFF], element: <SupplierList /> },
    { path: "/inventory/supplier/add", roles: [ROLES.ADMIN, ROLES.STAFF], element: <SupplierAdd /> },
    { path: "/inventory/supplier/:supplierId/edit", roles: [ROLES.ADMIN, ROLES.STAFF], element: <SupplierEdit /> },

    { path: "/inventory/report", roles: [ROLES.ADMIN, ROLES.STAFF], element: <InventoryReport /> },

    { path: "/inventory/recipe", roles: [ROLES.ADMIN, ROLES.STAFF], element: <RecipeList /> },
    { path: "/inventory/recipe/:recipeId/details", roles: [ROLES.ADMIN, ROLES.STAFF], element: <RecipeDetails /> },
    { path: "/inventory/recipe/add", roles: [ROLES.ADMIN, ROLES.STAFF], element: <RecipeAdd /> },
    { path: "/inventory/recipe/:recipeId/edit", roles: [ROLES.ADMIN, ROLES.STAFF], element: <RecipeEdit /> },

    { path: "/inventory/wastage", roles: [ROLES.ADMIN, ROLES.STAFF], element: <WastageList /> },
    { path: "/inventory/wastage/add", roles: [ROLES.ADMIN, ROLES.STAFF], element: <WastageAdd /> },
    { path: "/inventory/wastage/:wastageId/edit", roles: [ROLES.ADMIN, ROLES.STAFF], element: <WastageEdit /> },

    { path: "/inventory/final-report", roles: [ROLES.ADMIN, ROLES.STAFF], element: <InventoryFinalReport /> },


    /** Inventory ends */

    /** Order Archived */
    { path: "/reports/orders/archived", roles: [ROLES.ADMIN, ROLES.STAFF], element: <OrdersReportArchived /> },
    
    /** Only for Super Admin Routes */
    { path: "/restaurants", roles: [ROLES.SUPER_ADMIN], element: <Restaurant /> },
    { path: "/restaurants/:restaurantId/details", roles: [ROLES.SUPER_ADMIN], element: <RestaurantDetails /> },
    { path: "/restaurants/:restaurantId/edit", roles: [ROLES.SUPER_ADMIN], element: <RestaurantEdit /> },
    { path: "/restaurants/:restaurantId/branch/:branchId/floor-plan", roles: [ROLES.SUPER_ADMIN], element: <RestaurantFloorPlan /> },
    { path: "/restaurants/:restaurantId/branch/:branchId/floor-plan/add", roles: [ROLES.SUPER_ADMIN], element: <AddTable /> },
    { path: "/groups", roles: [ROLES.SUPER_ADMIN], element: <Group /> },
    { path: "/users", roles: [ROLES.SUPER_ADMIN], element: <Users /> },
    { path: "/restaurants-create", roles: [ROLES.SUPER_ADMIN], element: <RestaurantCreate /> },
    { path: "/restaurants/:restaurantId/branch/create", roles: [ROLES.SUPER_ADMIN], element: <BranchCreate /> },
    { path: "/restaurants/:restaurantId/branch/:branchId/edit", roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN], element: <BranchEdit /> },
    { path: "/restaurants/:restaurantId/branch/:branchId/details", roles: [ROLES.SUPER_ADMIN], element: <BranchDetail /> },
    { path: "/sales/orders", roles: [ROLES.SUPER_ADMIN], element: <SuperAdminOrderList /> },
    { path: "/sales/orders/:orderId/details", roles: [ROLES.SUPER_ADMIN], element: <OrderReportDetails /> },
    { path: "/sales/disbursement-history", roles: [ROLES.SUPER_ADMIN], element: <DisbursementHistory /> },
    { path: "/sales/disbursement", roles: [ROLES.SUPER_ADMIN], element: <Disbursement /> },
    { path: "/switch-restaurant", roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN], element: <RestaurantSwitch /> },
    { path: "/super-admin/settings", roles: [ROLES.SUPER_ADMIN], element: <SettingsSuperAdmin /> },

    /* Add Meal Addition Section*/
    { path: "/add-meal-addition", roles: [ROLES.ADMIN, ROLES.STAFF], element: <AddMealAddition /> },

    /** Table management waiter */
    { path: "/waiter/list", roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.STAFF], element: <WaiterList /> },
    { path: "/waiter/assign", roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.STAFF], element: <WaiterAssign /> },
];


export default {
    publicRoutes,
    roleBasedRoutes
};
